/**
 * Told the uid and ID token of a signed-in Firebase user BEFORE `/auth/login`
 * is awaited (`authService.onAuthStateChanged`), so boot work that needs only
 * the token can run alongside it (`lib/bootItemsPrefetch.ts`, registered in
 * `main.tsx`). A registry, not an import, so the auth service gains no
 * dependency on what boot prefetches. The hook's failures are its own: it must
 * never block or break the sign-in it runs alongside.
 */

type SessionRestoredHook = (uid: string, idToken: string) => void;

let hook: SessionRestoredHook | null = null;

export function onSessionRestored(next: SessionRestoredHook): void {
  hook = next;
}

export function notifySessionRestored(uid: string, idToken: string): void {
  try {
    hook?.(uid, idToken);
  } catch (error) {
    console.error('Session-restored hook failed:', error);
  }
}
